import { ProductProvider as ForwardAccumulatorProvider } from '@/App/tiles/ForwardAccumulator/ProductProvider.tsx';
import { Tile as ForwardAccumulatorTile } from '@/App/tiles/ForwardAccumulator/Tile.tsx';
import { OptionContext } from '@/App/tiles/Option/OptionContext.ts';
import { OptionTile } from '@/App/tiles/Option/OptionTile.tsx';
import { QueueContextProvider } from '@/App/tiles/Option/QueueContext.tsx';
import { TargetAccumulatorTile } from '@/App/tiles/TargetAccumulator/index.tsx';
import { TargetAccumulatorProvider } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TileCatchAll } from '@/components/fatality/TileCatchAll.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTileProductType } from '@/store/tiles/selectors.ts';

type Props = {
  tileId: string;
};

export const ZoomedTile = ({ tileId }: Props) => {
  const productType = useAppSelector((state) => selectTileProductType(state, tileId));

  return (
    <TileCatchAll tileId={tileId}>
      {productType === 'Option' && (
        <OptionContext value={tileId}>
          <QueueContextProvider>
            <OptionTile tileId={tileId} />
          </QueueContextProvider>
        </OptionContext>
      )}

      {productType === 'TargetAccumulator' && (
        <TargetAccumulatorProvider tileId={tileId}>
          <TargetAccumulatorTile tileId={tileId} />
        </TargetAccumulatorProvider>
      )}

      {productType === 'ForwardAccumulator' && (
        <ForwardAccumulatorProvider tileId={tileId}>
          <ForwardAccumulatorTile />
        </ForwardAccumulatorProvider>
      )}
    </TileCatchAll>
  );
};
